module.exports = __webpack_public_path__ + "static/seller2.6982aaba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/seller2.gif
// module id = 3201
// module chunks = 21364751940522